Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Divider1290317650",
  {"root":"Divider1290317650--root","MainColor":"color-5","MainWidth":"1","MainDividerColor":"color-5","MainDividerWidth":"1"},
  "",
  1,
  "Divider1290317650"
);

